import { render, staticRenderFns } from "./ClippedText.vue?vue&type=template&id=ffd4cdbc&"
import script from "./ClippedText.vue?vue&type=script&lang=js&"
export * from "./ClippedText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports